// TODO: Abstract the use of these images to use vector-image service
import iconImage from './assets/Satellite.png';

const { host } = window.location;
let domain = host;
if (host !== 'deckee.com') domain = 'staging.deckee.com';

export default {
  displayName: 'Satellite',
  iconImage,
  iconBackgroundColor: '#091B2B',
  style: `https://${domain}/public/map-tile-server/map-styles/satellite.json`,
};
